import { lazy } from "react";
const Dashboard = lazy(() => import("../pages/Dashboard"));
const Buses = lazy(() => import("../pages/Buses"));
const Trips = lazy(() => import("../pages/Trips"));
const Packages = lazy(() => import("../pages/Packages"));

const AdminChat = lazy(() => import("../pages/AdminChat"));
const AdminChatBox = lazy(() => import("../pages/AdminChatBox"));
const ProductDetails = lazy(() => import("../pages/BusDetails"));
// const Category = lazy(() => import("../pages/Category"));
const Request = lazy(() => import("../pages/Request"));
const Customers = lazy(() => import("../pages/Customers"));
const CustomersTravelHistory = lazy(() =>
  import("../pages/CustomersTravelHistory")
);

const Admins = lazy(() => import("../pages/Admins"));
const CustomerOrder = lazy(() => import("../pages/CustomerOrder"));
const Orders = lazy(() => import("../pages/Orders"));
const OrderInvoice = lazy(() => import("../pages/OrderInvoice"));
const Coupons = lazy(() => import("../pages/Coupons"));
const EditProfile = lazy(() => import("../pages/EditProfile"));
const RefundRequests = lazy(() =>
  import("../pages/RefundRequests/RefundRequests")
);
const Transactions = lazy(() => import("../pages/Transactions/Transactions"));
const FreeTickets = lazy(() => import("../pages/FreeTickets/FreeTickets"));
const AddBooking = lazy(() => import("../pages/AddBooking/AddBooking"));
const AdminCities = lazy(() => import("../pages/AdminCities"));
const BusStations = lazy(() => import("../pages/BusStations"));
const Commissions = lazy(() => import("../pages/Commissions/Commissions"));

/*
//  * ⚠ These are internal routes!
//  * They will be rendered inside the app, using the default `containers/Layout`.
//  * If you want to add a route to, let's say, a landing page, you should add
//  * it to the `App`'s router, exactly like `Login`, `CreateAccount` and other pages
//  * are routed.
//  *
//  * If you're looking for the links rendered in the SidebarContent, go to
//  * `routes/sidebar.js`
 */

const routes = [
  {
    path: "/admin/dashboard",
    component: Dashboard,
  },
  {
    path: "/admin/buses",
    component: Buses,
  },
  {
    path: "/admin/cities",
    component: AdminCities,
  },
  {
    path: "/admin/trips",
    component: Trips,
  },
  {
    path: "/admin/packages",
    component: Packages,
  },
  {
    path: "/admin/product/:id",
    component: ProductDetails,
  },
  {
    path: "/admin/customers",
    component: Customers,
  },
  {
    path: "/admin/customer/:id/travel-history",
    component: CustomersTravelHistory,
  },
  {
    path: "/admin/admins",
    component: Admins,
  },
  {
    path: "/admin/customer-order/:id",
    component: CustomerOrder,
  },
  {
    path: "/admin/request",
    component: Request,
  },
  {
    path: "/admin/bookings",
    component: Orders,
  },
  {
    path: "/admin/bookings/:id",
    component: OrderInvoice,
  },
  {
    path: "/admin/coupons",
    component: Coupons,
  },
  { path: "/admin/profile", component: EditProfile },

  {
    path: "/admin/edit-profile",
    component: EditProfile,
  },
  {
    path: "/admin/adminChat",
    component: AdminChat,
  },
  {
    path: "/admin/adminChatBox",
    component: AdminChatBox,
  },
  {
    path: "/admin/refundrequests",
    component: RefundRequests,
  },
  {
    path: "/admin/transactions",
    component: Transactions,
  },
  {
    path: "/admin/commissions",
    component: Commissions,
  },
  {
    path: "/admin/freetickets",
    component: FreeTickets,
  },
  {
    path: "/admin/addbooking",
    component: AddBooking,
  },
  {
    path: "/admin/bus-Stations",
    component: BusStations,
  },
];

export default routes;
